import { Outlet } from "@tanstack/react-router";

export function OnboardingLayout() {
  return (
    <div className="flex h-full flex-col bg-background">
      <Outlet />
    </div>
  );
}
